<template>
  <MerchantAuthLayout>
    <div class="w-full">
      <div class="pt-4 container text-center flex flex-col items-center">
        <img class="w-40 h-10" :src="image || logo" />
        <div class="flex flex-col justify-center items-center max-w-[360px] w-full">
          <RouterView :channel="'merchant'" />
        </div>
      </div>
    </div>
  </MerchantAuthLayout>
</template>

<script setup lang="ts">
import MerchantAuthLayout from '@/layouts/MerchantAuthLayout.vue';
import { computed } from 'vue';
import { RouterView } from 'vue-router';
import LogoImage from '../assets/logo.svg';

defineProps<{
  image?: string;
}>();

const logo = computed(() => {
  return LogoImage;
});
</script>
